import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { FetchArrearsRequestInput, PayrollFetchArrearsGraphQLRequest, PayrollFetchArrearsResponse } from '../types';

const payrollFetchArrearsQuery = gql`
  query PayrollFetchArrears($input: FetchArrearsRequestInput!) {
    payrollFetchArrears(input: $input) {
      code
      success
      message
      data {
        message
        totalCount
        arrears {
          id
          merchantId
          tenantId
          userId
          sourceMonth
          arrearCause
          targetPayrollMonth
          arrearDays
          rlopDays
          arrearComponents {
            id
            tenantId
            payrollArrearId
            componentId
            componentName
            componentSource
            sdiType
            formulae
            isAmountFixed
            includeInPayroll
            includeInCompensation
            createdAt
            updatedAt
            deletedAt
          }
          createdAt
          updatedAt
          deletedAt
        }
      }
    }
  }
`;

export const fetchArrears = (input: FetchArrearsRequestInput) => {
  return graphQLApi<PayrollFetchArrearsResponse, PayrollFetchArrearsGraphQLRequest>({
    query: payrollFetchArrearsQuery,
    queryVariables: { input },
  });
};

